import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-115" data-mp="1clz9obpw4bzq">
      <div className="mx-auto max-w-3xl" data-id="element-116" data-mp="18kdsie6bpbjq">
        <SectionHeading tone="dark" eyebrow="5 premium bonuses" title="And you’ll receive these 5 bonuses at no additional cost" subtitle="Designed specifically to eliminate the situations that create the most uncertainty in everyday renal practice." data-id="element-117" data-mp="18lff9fwpbmha" />

        <div className="mt-9 space-y-4 sm:mt-12 sm:space-y-5" data-id="element-118" data-mp="1wb9s3xh0tb1j">
          {bonuses.map(bonus => <article key={bonus.title} className="rounded-3xl bg-white p-5 sm:p-7" data-id="element-119" data-mp="1rc6mobx4p2t1">
              <img src={bonus.image} alt={`${bonus.title} — book, tablet and phone mockup`} className="mx-auto -mt-2 mb-2 w-full max-w-md sm:-mt-3 sm:mb-3" loading="lazy" data-id="element-120" data-mp="kvl18v0nbrvg" />
              <p className="inline-flex items-center gap-1.5 rounded-full bg-brick-600 px-3 py-1 text-[10.5px] font-extrabold uppercase tracking-[0.14em] text-white sm:text-[11px]" data-id="element-121" data-mp="1jt9ouiplktw4">
                <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-122" data-mp="1as1pdxbchn0g" />
                {bonus.tag}
              </p>
              <h3 className="mt-3 font-display text-[22px] font-bold leading-tight text-navy-900 sm:text-[28px]" data-id="element-123" data-mp="w3fafwpmqx9r">
                {bonus.title}
              </h3>
              <p className="mt-2.5 text-[14.5px] font-semibold leading-snug text-navy-700 sm:text-base" data-id="element-124" data-mp="10vypyz7vo2h7">
                {bonus.promise}
              </p>

              {bonus.intro ? <p className="mt-3.5 text-[13.5px] font-bold uppercase tracking-wide text-navy-400 sm:text-[14px]" data-id="element-125" data-mp="r4c7qix4h34y">
                  {bonus.intro}
                </p> : null}

              {bonus.items ? <ul className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-x-5" data-id="element-126" data-mp="i58mp9eeadnt">
                  {bonus.items.map(item => <li key={item} className="flex gap-2" data-id="element-127" data-mp="2f1lbz8pma1ae">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick-600" aria-hidden="true" data-id="element-128" data-mp="2f00i7lb4mmdl" />
                      <span className="text-[13.5px] font-medium leading-snug text-navy-700 sm:text-[14.5px]" data-id="element-129" data-mp="263001wenhkil">
                        {item}
                      </span>
                    </li>)}
                </ul> : null}

              {bonus.quotes ? <ul className="mt-3 space-y-2" data-id="element-130" data-mp="2tp6h1861yaky">
                  {bonus.quotes.map(quote => <li key={quote} className="rounded-xl border-l-[3px] border-brick-300 bg-cream px-3.5 py-2.5 text-[13.5px] font-medium italic leading-snug text-navy-700 sm:text-[14.5px]" data-id="element-131" data-mp="2or4v8fh8rx5s">
                      “{quote}”
                    </li>)}
                </ul> : null}

              {bonus.outro ? <p className="mt-3.5 text-[13.5px] font-medium leading-relaxed text-navy-600 sm:text-[14.5px]" data-id="element-132" data-mp="187xbran98h49">
                  {bonus.outro}
                </p> : null}

              <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-navy-100 pt-4" data-id="element-133" data-mp="1hz0aw6wmim0w">
                <span className="text-[12px] font-bold uppercase tracking-wide text-navy-400" data-id="element-134" data-mp="1lyj0hfze3la2">
                  Value {bonus.value}
                </span>
                <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide text-emerald-700" data-id="element-135" data-mp="1vwp01qxq4fbr">
                  Included free
                </span>
              </div>
            </article>)}
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-136" data-mp="1la4gti17lo3">
          <CTAButton label="I want the 5 bonuses included" subline="$195 in bonuses included at no extra cost." data-id="element-137" data-mp="6hiho1co54sm" />
        </div>
      </div>
    </section>;
}